import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { pageLoaderTypes } from 'consts/pageLoaderTypeConsts';

import {
  selectPageLoaderIsDisplayed,
  selectPageLoaderLoaderType,
} from 'selectors/pageLoader';

const PageLoader = ({ forceDisplay }) => {
  const pageLoaderIsDisplayed = useSelector(selectPageLoaderIsDisplayed);
  const pageLoaderType = useSelector(selectPageLoaderLoaderType);

  const shouldDisplay = !!(pageLoaderIsDisplayed || forceDisplay);

  if (!shouldDisplay) {
    return null;
  }

  const LoaderComponent =
    pageLoaderType.component || pageLoaderTypes.DEFAULT.component;

  return (
    <div data-testid="page-loader">
      <LoaderComponent />
    </div>
  );
};

PageLoader.propTypes = {
  forceDisplay: PropTypes.bool,
};

export default PageLoader;
